import { Outlet } from 'react-router-dom';

export function UnprotectedLayout() {
  return (
    <div className="h-[100vh] bg-page-gradient">
      <Outlet />
    </div>
  );
}
